/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import { Table, Button, message, Modal } from 'antd'
import { clickDownload, round } from '../../../util/index'
import { changeStringTime, changeToDecimal, fetchData } from '../../../util'
import { API_DOMAIN } from '../../../config'
import { OK } from '../../CheckOutAdvManage/constants'
const SALE = 1
const STOCK = 2
export default class extends React.Component {
  state = {
    isShowSaleDetail: false,
    isShowStockDetail: false,
    showingDataSource: [],
    sumNum: 0,
    currentEmployee_name: '',
  }
  getDataSource = (action, item) => {
    const endpoint =
      action === SALE
        ? `${API_DOMAIN}/BossApi/shiftCommoditySales?duty_record_id=${item.duty_record_id}`
        : `${API_DOMAIN}/BossApi/shiftCommodityStock?duty_record_id=${item.duty_record_id}`
    return fetchData(endpoint).then((res) => {
      if (res && 'data' in res && res.status === OK) {
        if (action === SALE) {
          res.data.map((item) => {
            this.setState((prev) => ({
              sumNum: prev.sumNum + item.sale_amount,
            }))
          })
        }
        const newList = res.data.map((item, idx) => {
          return {
            ...item,
            index: idx,
          }
        })
        this.setState({
          [action === SALE ? 'isShowSaleDetail' : 'isShowStockDetail']: true,
          currentEmployee_name: item.employee_name,
          showingDataSource: newList,
        })
      } else {
        message.error(res ? res.detail : '请求失败')
      }
    })
  }
  render() {
    const { shiftList, period } = this.props
    const {
      isShowSaleDetail,
      isShowStockDetail,
      showingDataSource,
      sumNum,
      currentEmployee_name,
      loading,
    } = this.state

    const columns = [
      {
        title: '当前员工',
        dataIndex: 'employee_name',
        key: 'employee_name',
      },
      {
        title: '开始时间',
        dataIndex: 'start_time',
        key: 'start_time',
        width: 200,
      },
      {
        title: '结束时间',
        dataIndex: 'logout_time',
        key: 'logout_time',
        width: 200,
      },
      {
        title: '时长',
        dataIndex: 'duration',
        key: 'duration',
        width: 120,
      },
      {
        title: '桌台费',
        dataIndex: 'snooker',
        key: 'snooker',
        width: 120,
      },
      {
        title: '棋牌房费',
        dataIndex: 'mahjong',
        key: 'mahjong',
        width: 120,
      },
      {
        title: '飞镖费',
        dataIndex: 'dart',
        key: 'dart',
        width: 120,
      },
      {
        title: '服务费',
        dataIndex: 'incomeServiceTotal',
        key: 'incomeServiceTotal',
        width: 120,
      },
      {
        title: '商品销售',
        dataIndex: 'commodity',
        key: 'commodity',
        width: 120,
      },
      {
        title: '会员充值',
        dataIndex: 'recharge',
        key: 'recharge',
        width: 120,
      },
      {
        title: '卡券',
        dataIndex: 'coupon_income',
        key: 'coupon_income',
        width: 120,
      },
      {
        title: '预订',
        dataIndex: 'incomeReservationTotal',
        key: 'incomeReservationTotal',
        width: 120,
      },  
      {
        title: '定时',
        dataIndex: 'incomeTiming',
        key: 'incomeTiming',
        width: 120,
      },    
      {
        title: '团购',
        dataIndex: 'incomeGroupOn',
        key: 'incomeGroupOn',
        width: 120,
      },   
      {
        title: '其他',
        dataIndex: 'incomeOther',
        key: 'incomeOther',
        width: 120,
      },                           
      {
        title: '现金',
        dataIndex: 'cash',
        key: 'cash',
        width: 120,
      },
      {
        title: '线上支付',
        dataIndex: 'incomeThirdPartyTotal',
        key: 'incomeThirdPartyTotal',
        width: 120,
      },
      {
        title: '银行卡',
        dataIndex: 'card',
        key: 'card',
        width: 120,
      },
      {
        title: '第三方',
        dataIndex: 'third_part',
        key: 'third_part',
        width: 120,
      },
      {
        title: '自定价',
        dataIndex: 'incomeCustomized',
        key: 'incomeCustomized',
        width: 120,
      },
      {
        title: '转收现金',
        dataIndex: 'cash_received',
        key: 'cash_received',
        width: 120,
      },
      {
        title: '现金收入',
        dataIndex: 'cash_income',
        key: 'cash_income',
        width: 120,
      },
      {
        title: '备用金录入',
        dataIndex: 'revolving_fund',
        key: 'revolving_fund',
        width: 120,
      },
      {
        title: '现金支出',
        dataIndex: 'cash_outcome',
        key: 'cash_outcome',
        width: 120,
      },
      {
        title: '转交现金',
        dataIndex: 'cash_handover',
        key: 'cash_handover',
        width: 120,
      },
      {
        title: '签单',
        dataIndex: 'sign',
        key: 'sign',
        width: 120,
      },
      {
        title: '充值赠送',
        dataIndex: 'recharge_gifts',
        key: 'recharge_gifts',
        width: 120,
      },
      {
        title: '现金尾款免收',
        dataIndex: 'cash_ceil',
        key: 'cash_ceil',
        width: 120,
      },
      {
        title: '会员充值消耗',
        dataIndex: 'club_wallet',
        key: 'club_wallet',
        width: 120,
      },
      {
        title: '商品销售',
        dataIndex: 'sale',
        key: 'sale',
        width: 120,
        render: (text, record) => {
          return (
            <Button
              type="link"
              onClick={() => this.getDataSource(SALE, record)}
            >
              查询销售
            </Button>
          )
        },
      },
      {
        title: '商品库存',
        dataIndex: 'stock',
        key: 'stock',
        width: 120,
        render: (text, record) => {
          return (
            <Button
              type="link"
              onClick={() => this.getDataSource(STOCK, record)}
            >
              查询库存
            </Button>
          )
        },
      },
    ]
    const saleColumn = [
      {
        title: '商品名称',
        dataIndex: 'commodity_name',
        key: 'commodity_name',
        width: 120,
      },
      {
        title: '数量',
        dataIndex: 'sale_number',
        key: 'sale_number',
        width: 120,
      },
      {
        title: '金额',
        dataIndex: 'sale_amount',
        key: 'sale_amount',
        width: 120,
        render: (text) => {
          return changeToDecimal(text)
        },
      },
    ]
    const stockColumn = [
      {
        title: '商品名称',
        dataIndex: 'commodity_name',
        key: 'commodity_name',
      },
      {
        title: '数量',
        dataIndex: 'commodity_stock',
        key: 'commodity_stock',
      },
    ]

    const clubId = sessionStorage.getItem('club_id')
    const isClubTest = sessionStorage.getItem('club_testing')
    if (!(clubId == 0 || isClubTest == 1)) {
      columns.splice(7, 1)
    }

    const data = []
    for (let index = 0; index < shiftList.length; index++) {
      const item = shiftList[index]
      const e = new Date(item.logout_time)
      const s = new Date(item.start_time)
      const durationNum = changeToDecimal(+(e - s) / 1000 / 60 / 60)
      data.push({
        ...item,
        index: index,
        duration: (isNaN(durationNum) ? 0 : durationNum) + '小时',
        snooker: round(+item.snooker / 100, 2),
        mahjong: round(+item.mahjong / 100, 2),
        commodity: round(+item.commodity / 100, 2),
        dart: round(+item.dart / 100, 2),
        recharge: round(+item.recharge / 100, 2),
        coupon_income: round(+item.coupon_income / 100, 2),
        cash: round(+item.cash / 100, 2),
        incomeThirdPartyTotal: round(+item.raw.incomeThirdPartyTotal / 100, 2),
        // wechat : round(+item.wechat / 100,2),
        // alipay : round(+item.alipay / 100,2),
        // union_wallet : round(+item.union_wallet / 100,2),
        card: round(+item.card / 100, 2),
        third_part: round(+item.third_part / 100, 2),
        cash_received: round(+item.cash_received / 100, 2),
        cash_income: round(+item.cash_income / 100, 2),
        revolving_fund: round(+item.revolving_fund / 100, 2),
        cash_outcome: round(+item.cash_outcome / 100, 2),
        cash_handover: round(+item.cash_handover / 100, 2),
        sign: round(+item.sign / 100, 2),
        group_on: round(+item.group_on / 100, 2),
        recharge_gifts: round(+item.recharge_gifts / 100, 2),
        cash_ceil: round(+item.cash_ceil / 100, 2),
        club_wallet: round(+item.club_wallet / 100, 2),
        incomeRentReservationTotal: round(
          +item.raw.incomeRentReservationTotal / 100,
          2
        ),
        incomeServiceTotal: round(+item.raw.incomeServiceTotal / 100, 2),
        incomeReservationTotal: round(item.raw.incomeReservationTotal / 100, 2),
        incomeTiming: round(item.raw.incomeTiming / 100, 2),
        incomeGroupOn: round(item.raw.incomeGroupOn / 100, 2),
        incomeOther: round(item.raw.incomeOther / 100, 2),
        incomeCustomized: round(item.raw.incomeCustomized / 100, 2)
      })
    }
    let reportName = sessionStorage.getItem('reportName')
    if (period && period.start_time && period.end_time) {
      reportName += `${changeStringTime(period.start_time)}-${changeStringTime(
        period.end_time
      )}`
    }
    const date =
      period && period.start_time && period.end_time
        ? `${changeStringTime(period.start_time)}-${changeStringTime(
            period.end_time
          )}`
        : ''
    return (
      <div style={{ marginTop: '1rem' }}>
        <div
          style={{
            cursor: 'default',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: '1rem',
          }}
        >
          <Button>
            <a
              id="test"
              href={clickDownload(columns, data)}
              download={`${reportName}.csv`}
            >
              导出
            </a>
          </Button>
        </div>
        <h3>交班报表记录</h3>
        <Table
          rowKey="index"
          bordered
          loading={loading}
          columns={columns}
          dataSource={data}
          scroll={{ x: (columns.length - 2) * 120 + 400 }}
          size="small"
        />
        {isShowSaleDetail && (
          <Modal
            title="商品销售"
            visible={isShowSaleDetail}
            onOk={() => this.setState({ isShowSaleDetail: false, sumNum: 0 })}
            onCancel={() =>
              this.setState({ isShowSaleDetail: false, sumNum: 0 })
            }
            footer={null}
          >
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <div style={{ width: 'fit-content' }}>
                合计: {changeToDecimal(sumNum)} 元
              </div>
              <Button>
                <a
                  id="test"
                  href={clickDownload(saleColumn, showingDataSource)}
                  download={`${currentEmployee_name}-${date}-商品销售.csv`}
                >
                  导出
                </a>
              </Button>
            </div>
            <Table
              rowKey="index"
              columns={saleColumn}
              dataSource={showingDataSource}
            />
          </Modal>
        )}
        {isShowStockDetail && (
          <Modal
            title="商品库存"
            visible={isShowStockDetail}
            onOk={() => this.setState({ isShowStockDetail: false })}
            onCancel={() => this.setState({ isShowStockDetail: false })}
            footer={null}
          >
            <Button>
              <a
                id="test"
                href={clickDownload(stockColumn, showingDataSource)}
                download={`${currentEmployee_name}-${date}-商品库存.csv`}
              >
                导出
              </a>
            </Button>
            <Table
              rowKey="index"
              columns={stockColumn}
              dataSource={showingDataSource}
            />
          </Modal>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubShift/component/report.js